<form
  class="archive-dialog"
  [formGroup]="archiveService.dateRangeForm"
  *ngIf="!showingNext; else showNext"
>
  <section class="archive-hero">
    <div class="archive-hero__icon" aria-hidden="true">
      <i class="pi pi-book"></i>
    </div>

    <div class="archive-hero__copy">
      <span class="archive-hero__eyebrow">Archive Vehicle</span>
      <h2>{{ data?.vehicle_reference || "Selected vehicle" }}</h2>
      <p>Select the record ranges that should move with this archive.</p>
    </div>
  </section>

  <div class="archive-detect" *ngIf="detecting">
    <i class="pi pi-spin pi-spinner"></i>
    <span>Checking the odometer history for a vehicle changeover…</span>
  </div>

  <div
    class="archive-detect"
    [class.archive-detect--found]="detectedResets.length > 0"
    *ngIf="!detecting && detectionMessage"
  >
    <i
      [class]="
        detectedResets.length
          ? 'pi pi-check-circle'
          : 'pi pi-info-circle'
      "
    ></i>
    <span>{{ detectionMessage }}</span>
    <button
      pButton
      type="button"
      label="Re-detect"
      icon="pi pi-refresh"
      class="p-button-sm p-button-text"
      (click)="detectChangeover()"
    ></button>
  </div>

  <section class="archive-section">
    <div class="archive-section__header">
      <div>
        <h3>Active issues</h3>
        <span>Open issues and fines</span>
      </div>
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    </div>

    <div class="archive-date-grid">
      <div class="archive-field">
        <label for="issueDateFrom">From</label>
        <p-calendar
          inputId="issueDateFrom"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
          formControlName="x_date_from"
        ></p-calendar>
      </div>

      <div class="archive-range-divider">to</div>

      <div class="archive-field">
        <label for="issueDateTo">To</label>
        <p-calendar
          inputId="issueDateTo"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
          formControlName="x_date_to"
        ></p-calendar>
      </div>
    </div>
  </section>

  <section class="archive-section">
    <div class="archive-section__header">
      <div>
        <h3>Technical records</h3>
        <span>Maintenance and workshop history</span>
      </div>
      <i class="pi pi-cog" aria-hidden="true"></i>
    </div>

    <div class="archive-date-grid">
      <div class="archive-field">
        <label for="technicalDateFrom">From</label>
        <p-calendar
          inputId="technicalDateFrom"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
          formControlName="y_date_from"
        ></p-calendar>
      </div>

      <div class="archive-range-divider">to</div>

      <div class="archive-field">
        <label for="technicalDateTo">To</label>
        <p-calendar
          inputId="technicalDateTo"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
          formControlName="y_date_to"
        ></p-calendar>
      </div>
    </div>
  </section>

  <div class="archive-actions">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      (click)="closeDialog()"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-arrow-right"
      label="Review archive"
      class="p-button-sm p-button-outlined"
      (click)="nextDialog()"
    ></button>
  </div>
</form>

<ng-template #showNext>
  <div
    class="archive-dialog"
    *ngIf="!showCreateVehicleDialog; else showCreateVehicle"
  >
    <form [formGroup]="archiveService.archiveForm">
      <section class="archive-hero">
        <div class="archive-hero__icon" aria-hidden="true">
          <i class="pi pi-check-circle"></i>
        </div>

        <div class="archive-hero__copy">
          <span class="archive-hero__eyebrow">Archive Review</span>
          <h2>{{ data?.vehicle_reference || "Selected vehicle" }}</h2>
          <p>Review the selected records before creating the archived vehicle.</p>
        </div>
      </section>

      <section class="archive-section">
        <div class="archive-section__header">
          <div>
            <h3>New archive reference</h3>
            <span>This reference will identify the archived vehicle copy.</span>
          </div>
          <i class="pi pi-tag" aria-hidden="true"></i>
        </div>

        <div class="archive-field">
          <label for="archiveVehicleReference">Vehicle Reference</label>
          <input
            id="archiveVehicleReference"
            pInputText
            type="text"
            [formControl]="
              archiveService.archiveForm.controls['vehicle_reference']
            "
            [readOnly]="true"
          />
        </div>
      </section>

      <section class="archive-section">
        <div class="archive-section__header">
          <div>
            <h3>Selected active issues</h3>
            <span>{{ activeIssues.length }} issues in range</span>
          </div>
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        </div>

        <p-table
          [value]="activeIssues"
          [paginator]="true"
          [rows]="5"
          [responsive]="true"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          responsiveLayout="scroll"
          [rowHover]="true"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="app-table archive-review-table p-datatable-sm lg:p-datatable-md"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of issueColumns"
                [pSortableColumn]="col.field"
              >
                <div class="flex align-items-center">
                  <span>{{ col.header }}</span>
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-activeIssue>
            <tr>
              <td
                *ngFor="let col of issueColumns"
                [class.mono-cell]="col.field === 'fine_amount'"
              >
                <span class="font-medium text-sm md:text-base text-color-primary">
                  {{ activeIssue[col.field] }}
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="getIssueColumns()">
                <div class="archive-empty-row">
                  <p-progressBar
                    *ngIf="loadingIssues"
                    mode="indeterminate"
                    styleClass="w-full"
                  ></p-progressBar>

                  <span *ngIf="!loadingIssues">
                    No active issues found for the selected range.
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>

      <section class="archive-section">
        <div class="archive-section__header">
          <div>
            <h3>Selected technical records</h3>
            <span>{{ technicalRecords.length }} records in range</span>
          </div>
          <i class="pi pi-cog" aria-hidden="true"></i>
        </div>

        <p-table
          [value]="technicalRecords"
          [paginator]="true"
          [rows]="5"
          [responsive]="true"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          responsiveLayout="scroll"
          [rowHover]="true"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="app-table archive-review-table p-datatable-sm lg:p-datatable-md"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngFor="let col of technicalColumns"
                [pSortableColumn]="col.field"
              >
                <div class="flex align-items-center">
                  <span>{{ col.header }}</span>
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-technicalRecord>
            <tr>
              <td
                *ngFor="let col of technicalColumns"
                [class.mono-cell]="
                  col.field === 'odometer' ||
                  col.field === 'date_completed' ||
                  col.field === 'chassis_no'
                "
              >
                <span
                  *ngIf="col.field === 'record_type'; else plainCell"
                  class="record-tag"
                >
                  {{ technicalRecord[col.field] }}
                </span>
                <ng-template #plainCell>
                  <span class="font-medium text-sm md:text-base text-color-primary">
                    {{ technicalRecord[col.field] }}
                  </span>
                </ng-template>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="getTechnicalColumns()">
                <div class="archive-empty-row">
                  <p-progressBar
                    *ngIf="loadingIssues"
                    mode="indeterminate"
                    styleClass="w-full"
                  ></p-progressBar>

                  <span *ngIf="!loadingIssues">
                    No technical records found for the selected range.
                  </span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>


      <div class="archive-actions">
        <button
          pButton
          type="button"
          icon="pi pi-arrow-left"
          label="Back"
          class="p-button-text"
          (click)="returnToPreviousDialog()"
        ></button>

        <button
          pButton
          type="button"
          icon="pi pi-arrow-right"
          label="Continue"
          class="p-button-sm p-button-outlined"
          (click)="showAddVehicleDialog()"
        ></button>
      </div>
    </form>
  </div>

  <ng-template #showCreateVehicle>
    <div class="archive-create-vehicle">
      <button
        pButton
        type="button"
        icon="pi pi-arrow-left"
        label="Back to review"
        class="p-button-sm p-button-text archive-create-vehicle__back"
        (click)="showCreateVehicleDialog = false"
      ></button>

      <app-create-vehicle
        [data]="data"
        [activeIssueData]="activeIssues"
        [technicalRecordData]="technicalRecords"
        [defaultInService]="detectedInServiceDate"
      ></app-create-vehicle>
    </div>
  </ng-template>
</ng-template>
